// extracted by mini-css-extract-plugin
export default {"Accessibility":"Accessibility_Accessibility__GPwsy","subhead":"Accessibility_subhead__5O5qj"};